import React, { Fragment, Component } from "react"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "redux"
import EmployeeDetailsSelectionModal from "./Modals/EmployeeDetailsSelectionModal"
import * as reportSelectionActions from "../../state/actions/reportSelectionActions"

class EmployeeDetailsSelection extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    setEmployeeDetails: PropTypes.func.isRequired,
    reportOptions: PropTypes.shape({
      employeeDetailOptions: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.number,
        label: PropTypes.string,
        selected: PropTypes.bool,
      })),
    }).isRequired,
    reportSelection: PropTypes.shape({ employeeDetailOptions: PropTypes.arrayOf(PropTypes.number) })
      .isRequired,
  }
  state = {
    showModal: false,
  }
  componentDidMount() {
    // If no options have been selected already then select the defaults.
    if (this.props.reportSelection.employeeDetailOptions.length === 0) {
      this.props.setEmployeeDetails(this.props.reportOptions.employeeDetailOptions)
    }
  }
  closePopup = () => {
    this.setState({ showModal: false })
  }
  editClicked = () => {
    this.setState({ showModal: true })
  }

  updateSelectedOptions = (newOptions) => {
    this.props.setEmployeeDetails(newOptions)
    this.closePopup()
  }

  render() {
    const { t, reportOptions, reportSelection } = this.props

    return (
      <Fragment>
        <div className="row form-group">
          <div className="col-lg-5 col-md-5">
            {t("CustomReport.EmployeeDetailsSelection.SelectText")} *
          </div>
          <div className="col-lg-4 col-md-4" style={{ color: "#999" }}>
            {reportSelection.employeeDetailOptions.length === 0
              ? t("CustomReport.Common.NoOptionSelected")
              : null}
            {reportSelection.employeeDetailOptions.length === 1
              ? t("CustomReport.Common.OneOptionSelected")
              : null}
            {reportSelection.employeeDetailOptions.length > 1
              ? `${reportSelection.employeeDetailOptions.length} ${t("CustomReport.Common.OptionsSelected")}`
              : null}
          </div>
          <div className="col-lg-3 col-md-3">
            <button className="btn" onClick={this.editClicked}>
              {t("CustomReport.Common.Edit")}
            </button>
          </div>
        </div>
        {this.state.showModal ? (
          <EmployeeDetailsSelectionModal
            closePopup={this.closePopup}
            employeeDetailOptions={reportOptions.employeeDetailOptions}
            updateSelectedOptions={this.updateSelectedOptions}
            selectedOptions={reportSelection.employeeDetailOptions}
          />
        ) : null}
      </Fragment>
    )
  }
}

function mapState(state) {
  return {
    reportOptions: state.customReport,
    reportSelection: state.reportSelection,
  }
}

function mapDispatch(dispatch) {
  return {
    setEmployeeDetails: (newOptions) => {
      dispatch(reportSelectionActions.setEmployeeDetailOptions(newOptions))
    },
  }
}

export default compose(translate(), connect(mapState, mapDispatch))(EmployeeDetailsSelection)



// WEBPACK FOOTER //
// ./src/components/custom-report/EmployeeDetailsSelection.jsx